<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-12-28 11:52:32
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterTemplate\RosterTemplate.vue
 -->
<template>
  <ContentLayout
    :title="$t('label_essweb_RosterTemplate_list_title')"
    :addBtn="hasBtn('add-admin-roster-template')"
    pad="0"
    @new="toNew"
    @activated="activated"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :showSelect="showSelect"
        :totalCount="totalCount"
        :filter-page-data="filterPageData"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="$getCommonLangValue(item.roster_weekly_template_name)"
          >
            {{ $getCommonLangValue(item.roster_weekly_template_name) }}
          </div>
        </template>
        <template v-slot:item.type="{ item }">
          <div class="text--primary table-title">{{ item.roster_type }}</div>
        </template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-roster-template')"
            :viewBtn="hasBtn('view-admin-roster-template')"
            :editBtn="hasBtn('edit-admin-roster-template')"
            :title="$t('label_essweb_RosterTemplate_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "RosterTemplate",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      search: "",
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_RosterTemplate_list_rosterTemplateNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.roster_weekly_template_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1 ||
              item.roster_weekly_template_description
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_RosterTemplate_list_rosterTemplateTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterPageData: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label: "label_essweb_RosterTemplate_list_rosterTemplateNameLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "name")
          data["roster_weekly_template_name"] = item.value;
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/roster-template/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/roster-template/edit/"
          : "/admin/roster-template/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_weekly_template",
        url: "/roster-template/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterTemplate_list_deleteRosterTemplateSuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
